export interface QualityMetrics {
  totalConversations: number
  /** null = sin conversaciones todavía; no se muestra 0% inventado. */
  botRatio: number | null
  humanRatio: number | null
  /** null = sin respuestas medibles en el período. */
  avgMinutes: number | null
  /** null = sin conversaciones; el backend ya decide el valor (0-100). */
  autonomousRate: number | null
  slaStatus: 'Inmediato' | 'En Rango' | null
  qualityRating: 'Excelente' | 'Normal' | null
}

/**
 * Normaliza lo que ya entrega el backend (`attendedByAssistantRate` en 0-100)
 * sin inventar porcentajes cuando no hay conversaciones.
 */
export function computeQualityMetrics(overview: {
  conversationsBot: number
  conversationsHuman: number
  conversationsAssistantInPeriod?: number
  conversationsHumanInPeriod?: number
  avgResponseTimeHours: number | null
  autonomousResolutionRate?: number | null
  attendedByAssistantRate?: number | null
}): QualityMetrics {
  const periodTotal =
    (overview.conversationsAssistantInPeriod ?? 0) + (overview.conversationsHumanInPeriod ?? 0)
  const total = periodTotal > 0
    ? periodTotal
    : overview.conversationsBot + overview.conversationsHuman
  const botRatio = overview.attendedByAssistantRate !== undefined
    ? overview.attendedByAssistantRate
    : total > 0
      ? Math.round((overview.conversationsBot / total) * 100)
      : null
  const humanRatio = botRatio === null ? null : 100 - botRatio
  const avgMinutes = overview.avgResponseTimeHours === null
    ? null
    : Math.round(overview.avgResponseTimeHours * 60)
  const autonomousRate = botRatio === null
    ? null
    : overview.autonomousResolutionRate != null
      ? Math.round(
          overview.autonomousResolutionRate <= 1
            ? overview.autonomousResolutionRate * 100
            : overview.autonomousResolutionRate
        )
      : botRatio

  return {
    totalConversations: total,
    botRatio,
    humanRatio,
    avgMinutes,
    autonomousRate,
    slaStatus: avgMinutes === null ? null : avgMinutes <= 2 ? 'Inmediato' : 'En Rango',
    qualityRating: autonomousRate === null ? null : autonomousRate >= 70 ? 'Excelente' : 'Normal',
  }
}
